import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div ref={ref} className="relative w-full max-w-[400px] mx-auto">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between gap-2 px-4 py-3 text-sm font-medium text-foreground-800 bg-background-50 border border-background-300/60 rounded-lg hover:border-primary-300 transition-colors cursor-pointer"
      >
        <span>Browse All Categories (14)</span>
        {open ? (
          <i className="ri-arrow-up-s-line w-4 h-4 flex items-center justify-center text-foreground-500"></i>
        ) : (
          <i className="ri-arrow-down-s-line w-4 h-4 flex items-center justify-center text-foreground-500"></i>
        )}
      </button>

      {open && (
        <div className="absolute top-full left-0 right-0 mt-1 bg-background-50 border border-background-200/70 rounded-lg overflow-hidden z-40 max-h-[360px] overflow-y-auto">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-600 transition-colors cursor-pointer"
            >
              <div
                className="w-9 h-9 rounded-md bg-cover bg-center flex-shrink-0"
                style={{ backgroundImage: `url('${cat.image}')` }}
              />
              <span dangerouslySetInnerHTML={{ __html: cat.name }}></span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}